import { Info } from "lucide-react";
import { SectionCard } from "../Domain/domainIntelligenceParts";
import { plainText } from "../utils";
import { humaniseFlag } from "./utilities";
import { MethodRow } from "./methodRow";

export interface ExtractionMethodSectionProps {
  llmPass?: string;
  groupingPass?: string;
  groupingMethod?: string;
  treeClauseText?: string;
}

export function ExtractionMethodSection({
  llmPass,
  groupingPass,
  groupingMethod,
  treeClauseText,
}: ExtractionMethodSectionProps) {
  if (!llmPass && !groupingPass && !groupingMethod && !treeClauseText) {
    return null;
  }

  return (
    <SectionCard headerLabel="Extraction method" rightLabel="Pipeline notes">
      <div className="flex items-start gap-2 p-4 text-[12.5px] text-foreground">
        <Info className="mt-0.5 size-4 flex-none text-indigo-600 dark:text-indigo-400" />
        <div className="min-w-0 flex flex-col gap-1.5">
          {llmPass && (
            <MethodRow label="LLM pass" value={humaniseFlag(llmPass)} />
          )}
          {(groupingPass || groupingMethod) && (
            <MethodRow
              label="Grouping"
              value={`${humaniseFlag(groupingPass)}${
                groupingMethod ? ` \u2014 ${plainText(groupingMethod)}` : ""
              }`}
            />
          )}
          {treeClauseText && (
            <MethodRow
              label="Tree clause text"
              value={plainText(treeClauseText)}
            />
          )}
        </div>
      </div>
    </SectionCard>
  );
}
